import type { ExperienceFilter } from './experience-state-types'

type ExperienceOptionLike = {
  id: string
  min?: number | null
}

type ExperienceVariantLike = {
  id: string
  options?: ExperienceOptionLike[] | null
}

type ExperienceWithVariants = {
  variants?: ExperienceVariantLike[] | null
}

export function normalizeInitialExperienceFilter(
  initialFilter: ExperienceFilter,
  experience: ExperienceWithVariants
): ExperienceFilter {
  const variant =
    experience.variants?.find(({ id }) => id === initialFilter.selectedVariant) ??
    experience.variants?.[0]
  const selectedVariant = variant?.id ?? ''
  const knownOptions = new Set(variant?.options?.map(option => option.id))
  const validOptions = Object.fromEntries(
    Object.entries(initialFilter.selectedOptions ?? {}).filter(
      ([id, count]) =>
        knownOptions.has(id) && Number.isInteger(count) && count >= 0 && count <= 2_147_483_647
    )
  )
  // Keep valid party preferences; only discard unknown options and malformed counts.
  const selectedOptions = Object.keys(validOptions).length
    ? validOptions
    : getDefaultSelectedOptions(experience, selectedVariant)

  return {
    ...initialFilter,
    selectedVariant,
    selectedOptions,
  }
}

function getDefaultSelectedOptions(
  experience: ExperienceWithVariants,
  selectedVariant: string
): ExperienceFilter['selectedOptions'] {
  const variant =
    experience.variants?.find(({ id }) => id === selectedVariant) ?? experience.variants?.[0]
  const firstOption = variant?.options?.[0]

  if (!firstOption?.id) {
    return undefined
  }

  return {
    [firstOption.id]: firstOption.min || 1,
  }
}
